import { GET_PRODUCTTYPES } from "./ProductTypeAction";

export const ProductTypeReducer = (state, action) => {
  switch (action.type) {
    case GET_PRODUCTTYPES:
      return {
        ...state,
        productTypes: action.payload,
      };
    default:
      return state;
  }
};

export default ProductTypeReducer;
